module.exports = __webpack_public_path__ + "img/result-header.c11eada3.png";